import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { take, switchMap, tap, of, Observable } from 'rxjs';
import { loadSidenavData, submitSearch } from '../../../../../../state/action';
import { AppState, Tab } from '../../../../../../state/app.state';
import { selectActiveTabDetails, selectSidenavDataByTabIdAndKey } from '../../../../../../state/selectors';
import { GeneralInnovationActivityResultsService } from '../../../../services/general-innovation-activity-results.service';
import { IKeywords, ITechnologyFootprint, ITopCompanies } from '../../../../../../core/models/results.model';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { NullableNumberPipe } from '../../../../../../shared/pipes/nullable-number.pipe';
import { PlotlyModule } from 'angular-plotly.js';
import { HttpResponse } from '@angular/common/http';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { CompanyThemePopupComponent } from '../company-theme-popup/company-theme-popup.component';

@Component({
  selector: 'app-technology-footprint',
  standalone: true,
  imports: [CommonModule, NgxPaginationModule, NullableNumberPipe, PlotlyModule, MatTooltipModule],
  templateUrl: './technology-footprint.component.html',
  styleUrls: ['./technology-footprint.component.css']
})
export class TechnologyFootprintComponent implements OnInit, OnChanges {
  @Input() tabId!: string;
  @Input() query: string | null = null; // Accept query
  @Input() entityids: string[] | null = null; // Accept entityids
  @Input() tab_name: string | null = null;
  @Input() search_type: string | null = null;

  constructor(private store: Store<AppState>, private apiService: GeneralInnovationActivityResultsService, private dialog: MatDialog) { }
  tabs$!: Observable<Tab | undefined>;
  ngOnInit(): void {
  }

  // Toggle query box
  toggleQueryBox(): void {
    this.showQueryBox = !this.showQueryBox;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabId']) {
      this.tabs$ = this.store.select(selectActiveTabDetails);
      this.showTechnologyFootprint = false;
      this.footprint_detailed_data_loading_failed = false;
      this.footprint_detailed_data = [];
      this.footprintData = [];
      this.footprintDetailed();
      this.techFootprint();
    }
  }


  showTechnologyFootprint: boolean = false;
  footprintData: any = [];
  paginator_2_page: number = 1;
  showQueryBox: boolean = false;
  footprint_detailed_data: any = [];
  footprint_detailed_data_loading_failed: boolean = false;
  showFootprintNoDataFound: boolean = false;
  showDetailedNoDataFound: boolean = false;
  footprintDetailed() {
    this.store.select(selectSidenavDataByTabIdAndKey(this.tabId, 'footprint_detailed')).pipe(
      take(1),
      switchMap((data) => {
        if (!data) {
          return this.apiService.getFootprintDetailed(this.query, this.entityids, this.tabId).pipe(
            tap((response) => {
              if (response.status === 204) {
                // No data found
                this.footprint_detailed_data = [];
                this.footprint_detailed_data_loading_failed = false;
                this.showDetailedNoDataFound = true;
                return;
              }

              if (response.body?.payload.tabId != this.tabId) {
                this.store.dispatch(loadSidenavData({
                  tabId: response.body!.payload.tabId,
                  sidenavKey: 'footprint_detailed',
                  data: response.body!.payload.results
                }));

                return;
              }
              if (response.body?.payload != null && response.body.payload.results && response.body.payload.results.length > 0) {
                this.store.dispatch(loadSidenavData({
                  tabId: this.tabId,
                  sidenavKey: 'footprint_detailed',
                  data: response.body.payload.results
                }));

                this.footprint_detailed_data = response.body.payload.results;
                this.showDetailedNoDataFound = false;
              } else {
                // Handle case where no data is found (empty results)
                this.footprint_detailed_data = [];
                this.footprint_detailed_data_loading_failed = false;
                this.showDetailedNoDataFound = true;
              }

            })
          );
        } else {
          this.footprint_detailed_data_loading_failed = false;
          this.footprint_detailed_data = data;
          return of();
        }
      })
    ).subscribe({
      next: () => {
      },
      error: (err) => {
        this.footprint_detailed_data_loading_failed = true;

      }
    });
  }





  footprint_data_loading_failed: boolean = false;
  techFootprint() {
    this.store.select(selectSidenavDataByTabIdAndKey(this.tabId, 'technology_footprint_data')).pipe(
      take(1),
      switchMap((data) => {
        if (!data) {
          return this.apiService.getTechnologyFootprint(this.query, this.entityids, this.tabId).pipe(
            tap((response) => {
              if (response.status === 204) {
                // No data found
                this.footprintData = [];
                this.footprint_data_loading_failed = false;
                this.showFootprintNoDataFound = true;
                return;
              }

              if (response.body?.payload.tabId != this.tabId) {
                this.store.dispatch(loadSidenavData({
                  tabId: response.body!.payload.tabId,
                  sidenavKey: 'technology_footprint_data',
                  data: response.body!.payload.results
                }));
                return;
              }
              if (response.body?.payload != null && response.body.payload.results && response.body.payload.results.length > 0) {
                this.store.dispatch(loadSidenavData({
                  tabId: this.tabId,
                  sidenavKey: 'technology_footprint_data',
                  data: response.body.payload.results
                }));

                this.footprintData = response.body.payload.results;
                this.showFootprintNoDataFound = false;
                this.plotTechFootprint();
              } else {
                // Handle case where no data is found (empty results)
                this.footprintData = [];
                this.footprint_data_loading_failed = false;
                this.showFootprintNoDataFound = true;
              }

            })
          );
        } else {
          this.footprint_data_loading_failed = false;
          this.footprintData = data;
          this.plotTechFootprint();
          return of();
        }
      })
    ).subscribe({
      next: () => {
      },
      error: (err) => {
        this.footprint_data_loading_failed = true;

      }
    });
  }

  techFootprintGraph: any = [];
  plotTechFootprint() {
    const colors = ["#00C9A7", "#56751c", "#5e1075", "#ff9500", "#7c0000", "#1f10bc", "#96c242", "#a442c2", "#6cd4ff", "#000000", "#ffd84d"];
    const footprint: ITechnologyFootprint[] = this.footprintData;
    const years = [...new Set(footprint.map(item => item.ype))];


    const techfields: string[] = [];
    footprint.forEach(item => {
      if (item.tf !== null && item.tf !== undefined && !techfields.includes(item.tf)) {
        techfields.push(item.tf);
      }
    });



    const techfieldColors: { [key: string]: string } = {};
    techfields.forEach((techfield, index) => {
      techfieldColors[techfield] = techfield === 'Others' ? '#808080' : colors[index];
    });


    const totalCounts: { [key: number]: number } = {};
    years.forEach(year => {
      totalCounts[year] = footprint.reduce((acc: number, item: ITechnologyFootprint) => {
        if (item.ype === year) {
          return acc + item.focus;
        }
        return acc;
      }, 0);
    });

    const data = techfields.map(techfield => {
      const techfieldData = years.map(year => {
        const total = totalCounts[year] || 1; // Avoid division by zero
        const dataPoint = footprint.find(item => item.tf === techfield && item.ype === year);
        return dataPoint ? (dataPoint.focus / total) * 100 : 0; // Normalize to percentage
      });

      return {
        x: years,
        y: techfieldData,
        type: 'bar',
        name: techfield,
        marker: { color: techfieldColors[techfield] },
        hovertemplate: 'Year: %{x}<br>Value: %{y:.1f}%',
      };
    });

    const layout = {
      annotations: [
        {
          xref: 'paper',
          yref: 'paper',
          x: 0.5,
          y: 1.04,
          xanchor: 'center',
          yanchor: 'bottom',
          text: '* The latest year is incomplete and considered year-to-date. ',
          showarrow: false,
          font: {
            size: 12,
            color: 'gray'
          }
        }],
      barmode: 'stack',
      xaxis: { title: 'Year', tickmode: 'linear', tick0: years[0], dtick: 1 },
      yaxis: { title: 'Percentage%' },
      //  width: 500,
      showlegend: true,
      legend: {
        orientation: 'h',
        y: -0.5,
        // x: 0.5,
        // xanchor: 'center',
        // yanchor: 'top',
        itemsizing: 'constant',

        font: { size: 10 },
      }
    };

    // Ensure "Others" is the first item in the data array
    const sortedData = data.sort((a, b) => {
      if (a.name === 'Others') return 1;
      if (b.name === 'Others') return -1;
      return 0;
    });

    // Assign the sorted data to the graph
    this.techFootprintGraph = {
      data: sortedData,
      layout: layout
    };
    this.showTechnologyFootprint = true;
  }
  submitTheme(theme: string) {
    const query = `tf="${theme}"`;
    const searchParams = { themes: [{ api_query: query, name: theme }] };
    this.store.dispatch(submitSearch({ searchParams, searchType: 'theme' }));
  }
  openCompanyPopup(theme: string) {
    const entityid = this.entityids?.[0];
    if (!entityid) return;
    this.dialog.open(CompanyThemePopupComponent, {
      width: '90vw',
      height: '85vh',
      maxWidth: '1200px',
      maxHeight: '800px',
      position: { top: '80px' },
      data: {
        entityid,
        entity_name: this.tab_name ?? '',
        theme_label: theme,
        theme_search_type: 'custom',
        query: `tf.tf2="${theme}"`,
        tabId: this.tabId,
      },
    });
  }
}
